module.exports = __webpack_public_path__ + "img/polygon.2177ee25.png";